import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ImportResponse } from "@/services/cav-offline-sync/types";
import { ImportInstructionsContent } from "./import-instructions-modal";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";

interface ImportButtonProps {
  onSuccess: (result: ImportResponse) => void;
}

export function ImportButton({ onSuccess }: ImportButtonProps) {
  const { handleModal } = useDialogModal();

  const handleButtonClick = () => {
    handleModal({
      isOpen: true,
      element: <ImportInstructionsContent onSuccess={onSuccess} />,
      title: "Importar Transacoes Processadas",
    });
  };

  return (
    <Button variant="outline" onClick={handleButtonClick}>
      <Upload className="h-4 w-4 mr-2" />
      Importar Processados
    </Button>
  );
}
